const msabahaData = {
  brand: "المسبحة",
  reset: "إعاده",
  start: "إضغط هنا لبد العد",
};

export default msabahaData;
